export default "__VITE_ASSET__fe61dc53__"